/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1NotificationMobileAppMutationRequest,
  PostApiV1NotificationMobileAppMutationResponse,
  PostApiV1NotificationMobileApp400,
  PostApiV1NotificationMobileApp401,
  PostApiV1NotificationMobileApp500,
} from "../../types/notificationMobileAppController/PostApiV1NotificationMobileApp.ts";

function getPostApiV1NotificationMobileAppUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/notification/mobile-app` as const,
  };
  return res;
}

/**
 * @description Cria uma notificação push para as turmas informadas. NotificationType deve ser Pendente (1), Agendado (2) ou Rascunho (6). Rascunho apenas salva o registro sem enfileirar no Hangfire. Agendado requer o campo ScheduledAtUtc preenchido. **(Requer Authorization para autenticação)**
 * @summary Cria uma notificação mobile (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app}
 */
export async function postApiV1NotificationMobileApp(
  data?: PostApiV1NotificationMobileAppMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1NotificationMobileAppMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1NotificationMobileAppMutationResponse,
    ResponseErrorConfig<
      | PostApiV1NotificationMobileApp400
      | PostApiV1NotificationMobileApp401
      | PostApiV1NotificationMobileApp500
    >,
    PostApiV1NotificationMobileAppMutationRequest
  >({
    method: "POST",
    url: getPostApiV1NotificationMobileAppUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
